import React, { FC, useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { AppContext } from '../contexts/AppContext';
import { hasFeature, FeatureFlag } from '../../../helpers/featureFlags';
import config from '../../../config';

interface Props {
  children: JSX.Element;
}

export const ProfileLocationOnlyRoute: FC<Props> = ({ children }) => {
  const { viewer, currentOrganization } = useContext(AppContext);
  const location = useLocation();

  if (!viewer?.profileLocationOnly || !currentOrganization) {
    return <>{children}</>;
  }
  const allowedPaths = [
    `/organizations/${currentOrganization.id}/profiles`,
    `/organizations/${currentOrganization.id}/locations`,
    `/organizations/${currentOrganization.id}/settings`,
    '/logout',
  ];

  const isAllowed = allowedPaths.some(path => location.pathname.startsWith(path));

  if (!isAllowed) {
    const isPdmV2Enabled = hasFeature(currentOrganization?.featureFlags, FeatureFlag.EnablePdmV2);

    if (isPdmV2Enabled) {
      window.location.href = `${config.endpoint}/organizations/${currentOrganization.id}/profiles`;
      return null;
    }
    return <Redirect to={`/organizations/${currentOrganization.id}/profiles`} />;
  }

  return <>{children}</>;
};
